export default "__VITE_ASSET__DnHXyc1t__"